/**
 * LandingFooter.tsx — bunn på offentlige sider (IBM-stil: mørk, lenkekolonner)
 *
 * Kolonnene sendes inn av siden (forsiden: plattform + moduler, /webhotell:
 * sine egne), så footeren kan deles av alle offentlige sider.
 */

import Link from 'next/link';
import type { LandingLink } from '@/types/landing';
import styles from './landing-sections.module.css';

export interface FooterColumn {
  heading: string;
  links: LandingLink[];
}

interface LandingFooterProps {
  tagline: string;
  legal: string;
  columns: FooterColumn[];
}

export default function LandingFooter({ tagline, legal, columns }: LandingFooterProps) {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerColumns}>
          <p className={styles.footerText}>{tagline}</p>

          {columns.map((column) => (
            <nav key={column.heading} aria-label={column.heading}>
              <h2 className={styles.footerHeading}>{column.heading}</h2>
              <ul className={styles.footerList} role="list">
                {column.links.map((link) => (
                  <li key={link.href + link.label}>
                    {link.href.startsWith('#') ? (
                      <a href={link.href} className={styles.footerLink}>
                        {link.label}
                      </a>
                    ) : (
                      <Link href={link.href} className={styles.footerLink}>
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className={styles.footerBottom}>
          <p className={styles.footerText}>
            © {new Date().getFullYear()} {legal}
          </p>
        </div>
      </div>
    </footer>
  );
}
